import React, { useRef } from 'react';
import './HamVideoPlayer.css';
import InfoBar from './InfoBar';

export default function HamVideoPlayer({ video, token,userRole, onClose }) {
  const videoRef = useRef(null);

  if (!video) return null;

  const videoId = video.AchievementVideoId;
  const videoTitle = video.AchievementVideoTitle ?? video.Title;
  const videoUrl = video.VideoUrl;
  const initialStatus = video.ApprovalStatus ?? null;

  return (
    <div className="ham-player-overlay" onClick={onClose}>
      <div className="ham-player-container" onClick={(e) => e.stopPropagation()}>
        <button className="ham-player-close" onClick={onClose} aria-label="Kapat">
          ✕
        </button>

        <div className="ham-player-video-area">
          <video
            ref={videoRef}
            controls
            controlsList="nodownload"
            autoPlay
            className="ham-player-video"
            src={videoUrl}
          >
            <source src={videoUrl} type="video/mp4" />
            Tarayıcınız video oynatmayı desteklemiyor.
          </video>
        </div>

        <InfoBar
          videoId={videoId}
          videoTitle={videoTitle}
          initialStatus={initialStatus}
          token={token}
          userRole={userRole}
        />
      </div>
    </div>
  );
}
